var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header-serial-number"},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('b',{staticClass:"main-header-serial-number--b",class:{ 'b-empty shine-short': !_vm.carLoaded && !this.entryNumber, blue:this.entryNumber }},[_vm._v("\n    "+_vm._s(_vm.carId)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }